import { CSSProperties } from "react";
import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";
import { Header, flexRender } from "@tanstack/react-table";
import CustomShuffle from "../../Atomos/Icons/CustomShuffle";
import SortAsending from "../../Atomos/Icons/SortAsending";
import SortDecending from "../../Atomos/Icons/SortDecending";
import SortDefault from "../../Atomos/Icons/SortDefault";
import { ISorting } from "../../../interfaces/Components/ITable";

const DraggableTableHeader = ({
  header,
  sorting,
  setSorting,
  allowSorting = true,
}: {
  header: Header<unknown, unknown>;
  sorting?: ISorting;
  setSorting?: React.Dispatch<React.SetStateAction<ISorting>>;
  allowSorting?: boolean;
}) => {
  const { attributes, isDragging, listeners, setNodeRef, transform } =
    useSortable({
      id: header.column.id,
    });

  const style: CSSProperties = {
    opacity: isDragging ? 0.8 : 1,
    position: "relative",
    transform: CSS.Translate.toString(transform),
    transition: "width transform 0.2s ease-in-out",
    whiteSpace: "nowrap",
    width: header.column.getSize(),
    zIndex: isDragging ? 1 : 0,
  };

  const toogleSortIcon = (field: string) => {
    if (setSorting) {
      if (sorting?.field === field && sorting.order === "desc") {
        setSorting({ field, order: "asc" });
      } else if (sorting?.field === field && sorting.order === "asc") {
        setSorting({ field, order: "desc" });
      } else {
        setSorting({ field, order: "desc" });
      }
    }
  };
  return (
    <th
      className="th"
      colSpan={header.colSpan}
      ref={setNodeRef}
      key={header.id}
      style={style}
    >
      <div className="flex">
        <button
          {...attributes}
          {...listeners}
          className="min-w-[1rem] fill-white flex items-center justify-end cursor-grab mr-2"
        >
          <CustomShuffle />
        </button>
        <span
          className="flex h-4 fill-white cursor-pointer"
          onClick={() => toogleSortIcon(String(header.column.id))}
        >
          <label>
            {flexRender(header.column.columnDef.header, header.getContext())}
          </label>
          <div
            onMouseDown={header.getResizeHandler()}
            onTouchStart={header.getResizeHandler()}
            className={`resizer ${header.column.getIsResizing() ? "isResizing" : ""} w-3`}
          />
          {allowSorting && (
            <>
              {sorting &&
                sorting.field === String(header.column.id) &&
                sorting.order === "asc" && <SortAsending />}
              {sorting &&
                sorting.field === String(header.column.id) &&
                sorting.order === "desc" && <SortDecending />}
              {(!sorting || sorting.field !== String(header.column.id)) && (
                <SortDefault />
              )}
            </>
          )}
        </span>
      </div>
    </th>
  );
};

export default DraggableTableHeader;
